import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

import AccountingHelper from "../utils/AccountingHelper";
import Api from "../utils/Api";
import ThemeHelper from "../utils/ThemeHelper";

import CurrencyActions from "./CurrencyActions";

// UserActions
export default {
	async loadUserProfile()
	{
		const userProfile = await Api.getUserProfile();
		if (!userProfile)
		{
			throw new Error("No user profile exists.");
		}
		AppDispatcher.dispatch({
			actionType: AppConstants.USERSTORE_RECEIVE_USERPROFILE,
			userProfile
		});
		if (userProfile.format)
		{
			await AccountingHelper.setFormat(userProfile.format, /*initialize*/ true);
		}

		if (userProfile.theme)
		{
			// TODO: BA-162 is there a way we can actually load this on first render?
			const theme = ThemeHelper.themes.find(t => t.name === userProfile.theme);
			try
			{
				await ThemeHelper.setTheme(theme, /*initialize*/ true);
			}
			catch (e)
			{
				console.error(e);
			}
		}

		if (userProfile.multipleCurrenciesEnabled)
		{
			try
			{
				await CurrencyActions.initialize();
			}
			catch (e)
			{
				console.error(e);
			}
		}

		return userProfile;
	}
};



// WEBPACK FOOTER //
// ./Components/actions/UserActions.jsx